import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { WhySection } from './components/WhySection';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { Differentiators } from './components/Differentiators';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SalesPopup } from './components/SalesPopup';
interface AppProps {
  showSalesPopup?: boolean;
}
export function App({
  showSalesPopup = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '2088545771738527');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="sudlygrs019b">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2088545771738527&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="studdqo0mp7y" />
      </noscript>
      <div className="flex min-h-screen w-full flex-col items-center overflow-x-hidden bg-ivory" data-id="element-2" data-mp="3ubzvsgflbtha">
        <main className="w-full max-w-3xl bg-white shadow-2xl" data-id="element-3" data-mp="d3crffrqyaar">
          <Hero data-id="element-4" data-mp="851m9icecnyv" />
          <WhySection data-id="element-5" data-mp="86mgt7ypo6wq" />
          <SystemOverview data-id="element-6" data-mp="864djrdmssfb" />
          <Modules data-id="element-7" data-mp="83qdt580as1f" />
          <LookInside data-id="element-8" data-mp="3gkv17sr2xrdt" />
          <Bonuses data-id="element-9" data-mp="3gmfu7dxqx29k" />
          <Differentiators data-id="element-10" data-mp="3glwabrojc3sw" />
          <Offer data-id="element-11" data-mp="3gj1qo2dcin0j" />
          <Guarantee data-id="element-12" data-mp="3bmjrrj4p5iw4" />
          <Testimonials data-id="element-13" data-mp="3bncpxvplb02n" />
          <FAQ data-id="element-14" data-mp="3bnurn7v0u6hy" />
          <FinalCTA data-id="element-15" data-mp="3bk720jsp648i" />
          <Footer data-id="element-16" data-mp="3qb7lrkyw9kjy" />
        </main>
        {showSalesPopup ? <SalesPopup data-id="element-17" data-mp="3qcr0v88tdpk5" /> : null}
      </div>
    </>;
}